import React from "react";
import {observable, toJS} from "mobx";
import {IconeDelete, sortCaret} from "../../../comum/components/Icones";
import {appendFieldSpan, montarSelectOption, situacaoFormatter, splitBR, listEmailFormatter} from "../../../../utils/formatar";
import LoadingImage from "../../../comum/components/LoadingImage";
import {buscaFiltrarVazio, buscaSemResultado} from "../../../../utils/mensagens";
import {Button, Col, Row} from "reactstrap";
import Checkbox from "../../../comum/components/Checkbox";

export default class CabotagemStore {

    @observable naviosFiltros;
    @observable loadingNavios;
    estadoFiltros;

    @observable cabotagemLista;

    @observable listaMensagens;

    @observable inserindoXml;

    @observable posEditando;
    estadoEditando;

    @observable outrosDados;

    @observable lista;
    @observable itens;
    toShow;
    turn;
    @observable hasMore;
    @observable noData;
    @observable linhaExpandida;
    @observable tableMessage;
    @observable loading;

    @observable novasCabotagens;
    novasCabotagensLength;
    @observable inserindo;
    @observable sucessoInserirCabotagem;
    @observable colunasN;
    @observable salvando;

    @observable modalInativar;
    @observable todosMarcados;
    @observable selecionados;
    @observable inativandoLoading;

    constructor(service) {
        this.naviosFiltros = false;
        this.loadingNavios = true;
        this.estadoFiltros = false;

        this.cabotagemLista = [];
        this.listaMensagens = false;

        this.posEditando = -1;
        this.estadoEditando = {};

        this.colunas = this.todasColunas;

        // Scroll infinito
        this.lista = [];
        this.toShow = 20;
        this.turn = 0;
        this.itens = [];
        this.hasMore = false;
        this.noData = <LoadingImage />;
        this.tableMessage = buscaFiltrarVazio;
        this.loading = false;

        // Area de inclusão
        this.novasCabotagens = [];
        this.novasCabotagensLength = 0;
        this.inserindo = false;
        this.sucessoInserirCabotagem = false;
        this.colunasN = this.colunasNovas;
        this.salvando = false;
        this.regimes = [
            {value: "Porta/Porta", label: "Porta / Porta"},
            {value: "Porta/Porto", label: "Porta / Porto"},
            {value: "Porto/Porto", label: "Porto / Porto"},
            {value: "Porto/Porta", label: "Porto / Porta"}
        ]

        // Area da inativação
        this.modalInativar = false;
        this.todosMarcados = false;
        this.selecionados = [];
        this.inativandoLoading = false;

        this.service = service;

        this.outrosDados = [
            { titulo : "Cliente", field: ["Cliente"], id:"F1", hidden: false},
            { titulo : "Criado por", field: ["UsuarioCadastro"], id:"F2", hidden: false},
            { titulo : "Inativado por", field: ["UsuarioInativou"], id:"F3", hidden: false},
            { titulo : "Email", formatter: listEmailFormatter ,field: ["Email"], id:"F4", hidden: false},
            { titulo : "Observacao", field: ["Observacao"], id:"F5", hidden: false}
        ];

        this.addAcoesColNovas();
    };

    addAcoesColNovas = () => {
        this.colunasN.push({
            dataField: 'acoes',
            isDummyField: true,
            text: 'Ação',
            formatter: (cell, row) => {
                return <div>
                    <Button onClick={ () => this.abrirEditar(row) } className="btn-acoes btn-com-bordas-cinza">Editar</Button>
                </div>
            }
        });
        this.colunasN.push({
            dataField: 'excluir',
            isDummyField: true,
            text: 'Excluir',
            align: (cell, row, rowIndex, colIndex) => 'center',
            formatter: (cell, row) => {
                return <div>
                    <IconeDelete className="" tamanho="2x" onClick={() => this.removerNova(row.pos)} />
                </div>
            }
        });
    };

    carregarDados = () => {
        this.service.listarNavios().then(response => {
            if (response.data) {
                this.naviosFiltros = montarSelectOption("OprOperacao", "NavioViagem", response.data);
                this.loadingNavios = false;
            }
        });

        // TODO Carregar Dietas ops Regimes
    };

    // Area lisgatem
    listar(filtros) {
        this.estadoFiltros = filtros;
        this.fazerListar(filtros);
    };

    reListar = () => {
        this.fazerListar(this.estadoFiltros);
    };

    fazerListar = (filtros) => {
        this.selecionados = [];
        this.cabotagemLista = [];
        this.lista = [];
        this.itens = [];
        this.loading = true;
        this.service.listar(filtros.operacao, filtros.cte, filtros.cntr, filtros.chave, filtros.situacao).then(response => {
            this.loading = false;
            if (response.data) {
                this.cabotagemLista = response.data;
            }
            if(this.cabotagemLista.length === 0) {
                this.tableMessage = buscaSemResultado
            } else {
                this.tableMessage = buscaFiltrarVazio
            }
            this.lista = this.cabotagemLista;

            this.noData = this.tableMessage;
            this.loadFirstTurn();
        });
    };

    loadFirstTurn = () => {
        this.itens = this.cabotagemLista.slice(0, this.toShow);
        this.turn = 1;
        this.hasMore = this.itens.length < this.lista.length;
    };

    loadNextTurn = () => {
        this.itens = [];
        this.itens = this.lista.slice(0, (this.turn+1)*this.toShow);
        this.turn = this.turn+1;

        this.hasMore = this.itens.length < this.lista.length;
    };
    // Fim Area listagem

    // Area incluão
    incluirCabotagem = (novaCabotagem) => {
        if (this.posEditando === -1) {
            if (this.novasCabotagens.length === 0) this.novasCabotagensLength = 0;
            novaCabotagem.pos = this.novasCabotagensLength;
            this.novasCabotagensLength++;
            this.novasCabotagens.push(novaCabotagem);
        } else {
            this.novasCabotagens[this.posEditando] = novaCabotagem;
        }
        this.posEditando = -1;
        this.inserindo = false;
    };

    incluirListaCabotagem = (listaNovas, navio) => {
        if (this.novasCabotagens.length === 0) this.novasCabotagensLength = 0;
        listaNovas.map(n => {
            n.pos = this.novasCabotagensLength;
            n.Navio = navio;
            this.novasCabotagensLength++;
            this.novasCabotagens.push(n);

            this.inserindoXml = false;
        });
    };

    removerNova = (pos) => {
        this.novasCabotagens = this.novasCabotagens.filter(n => n.pos !== pos);
    };

    salvarNovas = () => {
        this.salvando = true;
        this.service.salvar(this.novasCabotagens).then(response => {
            if (response.data) {
                this.sucessoInserirCabotagem = response.data.Sucesso;
                this.listaMensagens = splitBR(response.data.MensagemAlerta);
                this.listaMensagens.push(splitBR(response.data.MensagemErro));
                if (this.sucessoInserirCabotagem){
                    this.cancelarEnviar();
                    if(this.estadoFiltros) this.reListar();
                }
            } else {
                this.listaMensagens = "Problemas ao salvar"
            }
            this.salvando = false;
        }).catch(err => { console.log(err); });
    };

    abrirEditar = (row) => {
        this.posEditando = this.novasCabotagens.indexOf(this.novasCabotagens.find(c => c.pos === row.pos));
        this.estadoEditando = Object.assign({}, row);
    };

    cancelarInclusao = () => {
        this.inserindo = false;
        this.posEditando = -1;
    };

    cancelarEnviar = () => {
        this.novasCabotagens = [];
        this.novasCabotagensLength = 0;
    };
    // Fim Area inclusão

    marcar = (cabotagem) => {
        cabotagem.marcado = !cabotagem.marcado;
        this.selecionados = this.itens.filter(i => i.marcado===true);
    };

    marcarTodas = (checked) => {

        this.itens.map(item => 
                item.marcado = checked
            )

        this.selecionados = this.itens.filter(i => i.marcado === true)

    };

    abrirModalInativar = () => {
        this.modalInativar = true;
    };

    confirmarInativar = () => {
        this.service.inativar(this.selecionados).then(response => {
            this.modalInativar = false;
            if (response.data) {
                this.sucessoInserirCabotagem = response.data.Sucesso;
                this.listaMensagens = splitBR(response.data.MensagemAlerta);
                this.listaMensagens.push(splitBR(response.data.MensagemErro));
                this.reListar();
            } else {
                this.listaMensagens = "Problemas ao tentar inativar"
            }
        })
    };

    cancelaInativar = () => {
        this.modalInativar = false;
    };
    // Fim Inativar

    // Exportar
    getLista() {
        return this.cabotagemLista;
    }

    getListaCopia() {
        return toJS(this.cabotagemLista)
    }
    // Fim Exportar

    ativo = (row, todosMarcados) => {
        return (row.marcado || todosMarcados)
    };

    todasColunas = [{
        dataField: 'Cte',
        text: 'CTe',
        sort: true,
        style:{maxWidth:'150px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Chave',
        text: 'Chave Cte',
        sort: true,
        classes: 'chave-cte',
        //style:{maxWidth:'100px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Booking',
        text: 'Booking',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Cntr',
        text: 'Container',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Regime',
        text: 'Regime',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Navio',
        text: 'Navio/Viagem',
        sort: true,
        formatter: appendFieldSpan,
        formatExtraData: 'Operacao',
        style:{maxWidth:'150px', overflowWrap: 'break-word'},
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'StatusDsc',
        text: 'Situação',
        headerStyle: () => { return { maxWidth: "60px" }; },
        formatter: situacaoFormatter,
        sort: true,
        sortCaret: sortCaret,
    }];

    colunasNovas = [
    {
        dataField: 'Navio',
        text: 'Navio/Viagem',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Cte',
        text: 'CTe',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Chave',
        text: 'Chave Cte',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Cntr',
        text: 'Container',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Regime',
        text: 'Regime',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
    }, {
        dataField: 'Email',
        text: 'Email',
        sort: true,
        sortCaret: sortCaret,
        headerAlign: (column, colIndex) => 'left',
        formatter: listEmailFormatter
    }];

    colunasExportacao = [
        {
            dataField: 'Cte',
            text: 'CTe',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Chave',
            text: 'Chave Cte',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Booking',
            text: 'Booking',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Cntr',
            text: 'Container',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Regime',
            text: 'Regime',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'Navio',
            text: 'Navio/Viagem',
            sort: true,
            formatter: appendFieldSpan,
            formatExtraData: 'Operacao',
            sortCaret: sortCaret,
        },{
            dataField: 'StatusDsc',
            text: 'Situação',
            formatter: situacaoFormatter,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: "Cliente",
            text : "Cliente",
            sort: true,
            sortCaret: sortCaret
        },{
            dataField: "UsuarioCadastro",
            text : "Criado por",
            sort: true,
            sortCaret: sortCaret
        },{
            dataField: "UsuarioInativou",
            text : "Inativado por",
            sort: true,
            sortCaret: sortCaret
        },{
            dataField: "Email",
            text : "Email",
            formatter: listEmailFormatter,
            sort: true,
            sortCaret: sortCaret
        },{
            dataField: "Observacao",
            text : "Observacao",
            sort: true,
            sortCaret: sortCaret
        }
    ]
}


// WEBPACK FOOTER //
// ./src/modules/liberacoes/cabotagem/stores/CabotagemStore.js